/**
 * Import dependencies.
 */
import {h, Component} from 'preact';
import classnames from 'classnames/dedupe';

/**
 * Import styles.
 */
import '@material/list/mdc-list.scss';

/**
 * Import local dependencies.
 */
import './index.scss';
/**
 * Create the component.
 */
export default class List extends Component {
  render({
           'class': className,
           children,
           links,
           dense,
           twoLine,
           avatar,
           ...props
         }, state, context) {
    const classes = classnames('mdc-list', {
      'mdc-list--dense': dense,
      'mdc-list--two-line': twoLine,
      'mdc-list--avatar-list': avatar
    }, className);
    return links ? <div class={classes} {...props}>{children}</div> : <ul class={classes} {...props}>{children}</ul>;
  }
}



// WEBPACK FOOTER //
// ../q-mdc/elements/material-list/index.js